import React, { useEffect, useState } from 'react';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from '../firebaseconfig';
import { checkGovOpsEntitlement } from '../api/govopsPermitService';
import { GOVOPS_ENTITLEMENT_MSG } from '../api/govopsExceptions';

/**
 * Shown when signed in but SD Panthers has not granted entitlements.govops for this Firebase uid.
 */
const GovOpsEntitlementBanner = () => {
  const [uid, setUid] = useState(null);
  const [needsGrant, setNeedsGrant] = useState(false);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    if (!auth) {
      setChecking(false);
      return undefined;
    }

    const unsub = onAuthStateChanged(auth, async (user) => {
      setUid(user?.uid || null);
      if (!user) {
        setNeedsGrant(false);
        setChecking(false);
        return;
      }
      setChecking(true);
      const result = await checkGovOpsEntitlement();
      setNeedsGrant(result.state === 'forbidden');
      setChecking(false);
    });

    return () => unsub();
  }, []);

  if (checking || !needsGrant || !uid) return null;

  return (
    <div
      className="rhs-error-panel"
      role="alert"
      style={{ margin: '0 0 1rem', borderRadius: 0 }}
    >
      <strong>GovOps access required</strong>
      <p className="rhs-muted" style={{ marginTop: '0.5rem' }}>
        {GOVOPS_ENTITLEMENT_MSG}
      </p>
      <p className="rhs-muted" style={{ marginTop: '0.5rem', fontFamily: 'monospace', fontSize: '0.85rem' }}>
        Your Firebase UID: <strong>{uid}</strong>
      </p>
      <p className="rhs-muted" style={{ marginTop: '0.5rem', fontSize: '0.85rem' }}>
        Admin (repo):{' '}
        <code>cd firepermit && npm run setup:govops:demo -- {uid}</code>
      </p>
    </div>
  );
};

export default GovOpsEntitlementBanner;
